import React from "react";
import { Typography, Box, Stack } from "@mui/material";
const iconSx = {
  width: { xs: "96px", sm: "140px", md: "180px" },
  height: "auto",
};
const arrowSx = {
  alignSelf: "center",
  display: { xs: "none", md: "block" },
  mx: { md: 3 },
};
const titleSx = {
  color: "#333",
  fontSize: { xs: "1.125rem", sm: "1.25rem", md: "1.5rem" },
  fontWeight: 700,
};
const descriptionSx = {
  color: "#767676",
  fontWeight: 400,
  fontSize: { xs: "0.9375rem", sm: "1rem", md: "1.125rem" },
};
const iconPaths = {
  bookingConfirmed:'/assets/landingPageIcons/HIW-booking-confirmed.svg',
  receiveOffer:'/assets/landingPageIcons/HIW-receive-offers.svg',
  selectOffer:'/assets/landingPageIcons/HIW-select-offers.svg',
  submitEnquiry:'/assets/landingPageIcons/HIW-submit-enquiry.svg',
  tracking:"/assets/landingPageIcons/HIW-tracking.svg"
}

function HowItWorks() {
  return (
    <Box
      sx={{
        background: "#F8FAF8",
        paddingBlock: { xs: "2.5rem", md: "3rem" },
        px: { xs: 2.5, md: 0 },
      }}
    >
      <Typography
        align="center"
        sx={{
          color: "#333",
          marginBottom: "2rem",
          fontSize: { xs: "2rem", md: "2.25rem" },
          fontWeight: 700,
          textAlign: "center",
        }}
      >
        How It Works
      </Typography>
      <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems={{ xs: "stretch", md: "flex-start" }}
        justifyContent="center"
        spacing={{ xs: 4, md: 6 }}
        maxWidth="xl"
        sx={{ margin: "auto" }}
      >
        <Box
          height="100%"
          width={{ xs: "100%", sm: "85%", md: "250px" }}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <Box
            component="img"
            src={iconPaths.submitEnquiry}
            sx={iconSx}
            alt="submit-enquiry"
          />
          <Typography sx={titleSx}>Submit Enquiry</Typography>
          <Typography align="center" sx={descriptionSx}>
            Tell us what you need to transport. Fill in the details of your
            goods and submit your enquiry.
          </Typography>
        </Box>
        <Box sx={arrowSx}>
          <img src="/assets/icons/Union.svg" alt="Next step arrow" />
        </Box>

        <Box
          width={{ xs: "100%", sm: "85%", md: "250px" }}
          height="100%"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={iconPaths.receiveOffer}
            sx={iconSx}
            alt="recieve-offers"
          />
          <Typography sx={titleSx}>Receive Offers</Typography>
          <Typography align="center" sx={descriptionSx}>
          Our unique algorithm filters the best bids from a network of trusted transport partners.
          </Typography>
        </Box>
        <Box sx={arrowSx}>
          <img src="/assets/icons/Union.svg" alt="Next step arrow" />
        </Box>

        <Box
          width={{ xs: "100%", sm: "85%", md: "250px" }}
          height="100%"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={iconPaths.selectOffer}
            sx={iconSx}
            alt="recieve-offers"
          />
          <Typography sx={titleSx}>Select Offers</Typography>
          <Typography align="center" sx={descriptionSx}>
          Review the bids and select the offer of your choice.
          </Typography>
        </Box>
        <Box sx={arrowSx}>
          <img src="/assets/icons/Union.svg" alt="Next step arrow" />
        </Box>

        <Box
          width={{ xs: "100%", sm: "85%", md: "250px" }}
          height="100%"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={iconPaths.bookingConfirmed}
            sx={iconSx}
            alt="select offers"
          />
          <Typography sx={titleSx}>Confirm Booking</Typography>
          <Typography align="center" sx={descriptionSx}>
          Make a secure payment through our platform to confirm your booking.
          </Typography>
        </Box>
        <Box sx={arrowSx}>
          <img src="/assets/icons/Union.svg" alt="Next step arrow" />
        </Box>

        <Box
          width={{ xs: "100%", sm: "85%", md: "250px" }}
          height="100%"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={iconPaths.tracking}
            sx={iconSx}
            alt="tracking"
          />
          <Typography align="center" sx={titleSx}>
            Tracking
          </Typography>
          <Typography align="center" sx={descriptionSx}>
          Track your vehicle till your goods are delivered safely.
          </Typography>
        </Box>
        
      </Stack>
    </Box>
  );
}
export default HowItWorks;